import {
  Card,
  Heading,
  ItemTeaser,
  Layout,
  Button,
  Paragraph,
  ContentSection,
  Icon,
  IconName,
} from '@vwfs-bronson/bronson-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import imageMotorInsurance from '../../../../assets/images/confirmation-page-MotorInsurance.jpg'
import imagePayByPhone from '../../../../assets/images/confirmation-page-PayByPhone.png'
import CustomerHappinessIndex from '../../../../components/CustomerHappinessIndex'
import { Analytics, AnalyticsEvent } from '../../../../services/analytics'
import { PageName } from '../../../../services/analytics/enum'
import { setActualPage } from '../../../../services/redux/features/page'
import './index.css'

export default function EsignSuccessful({ transaction }) {
  const { t } = useTranslation()

  React.useEffect(() => {
    Analytics.track(new AnalyticsEvent.SuccessPageView(transaction))

    setActualPage(PageName.SUCCESS_PAGE)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const trackPhoneLinkClick = () => {
    Analytics.track(new AnalyticsEvent.SuccessPagePhoneClick(transaction))
  }

  const trackExitToAssurance = () => {
    Analytics.track(new AnalyticsEvent.SuccessPageExitToAssurance(transaction))
  }

  const trackExitToPayByPhone = () => {
    Analytics.track(new AnalyticsEvent.SuccessPageExitToPayByPhone(transaction))
  }

  const trackExitToDealerSearch = () => {
    Analytics.track(new AnalyticsEvent.SuccessPageExitToDealerSearch(transaction))
  }

  return (
    <React.Fragment>
      <ContentSection pageWrapSize="small">
        <div className="u-text-center">
          <Icon name={IconName.SUCCESS} className="u-text-success" />
        </div>
        <Heading level={1}>{t('confirmation:thankYou')}</Heading>

        <Paragraph>{t('confirmation:greetings:paragraph0')}</Paragraph>
        <Paragraph>{t('confirmation:greetings:paragraph1')}</Paragraph>
        <Paragraph>
          {t('confirmation:greetings:paragraph2')}{' '}
          <a href={t('confirmation:greetings:withdrawalLink')} target="_blank">
            {t('confirmation:greetings:withdrawalLinkText')}
          </a>
        </Paragraph>
      </ContentSection>

      <ContentSection pageWrapSize="small">
        <CustomerHappinessIndex transactionId={transaction} />
        <hr className="u-m-none" />
      </ContentSection>

      <ContentSection pageWrapSize="small">
        <Paragraph>{t('confirmation:ifYouHaveQuestions')}</Paragraph>
        <Layout>
          <Layout.Item default="1/2" s="1/1">
            <ItemTeaser
              icon={t('confirmation:iconTelephone')}
              inline
              title={t('confirmation:telephone')}
              className="fr-fix-icon"
            >
              <a
                onClick={trackPhoneLinkClick}
                href={`tel:${t('confirmation:contactTelephone')}`}
              >
                {t('confirmation:contactTelephone')}
              </a>
              {t('confirmation:freeLine')}
              <span className="u-block">{t('confirmation:phonelineOpen')}</span>
            </ItemTeaser>
          </Layout.Item>
        </Layout>
      </ContentSection>
      <ContentSection pageWrapSize="small">
        <Layout>
          <Layout.Item default="1/1">
            <Paragraph>
              {t('confirmation:findNextServicePoint')}
              <a
                onClick={trackExitToDealerSearch}
                href={t('page:storeLocatorLink')}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('confirmation:findNextServicePointLink')}
              </a>
            </Paragraph>
          </Layout.Item>
          <Layout.Item default="1/2" s="1/1">
            <Card
              onClick={trackExitToAssurance}
              imageSrc={imageMotorInsurance}
              ariaLabel={t('confirmation:MotorInsuranceTitle')}
              title={t('confirmation:MotorInsuranceTitle')}
              subtitle={t('confirmation:MotorInsuranceText')}
              element="article"
            >
              <Button
                link
                secondary
                element="a"
                target="_blank"
                icon="semantic-forward"
                href={t('confirmation:MotorInsurance:link')}
              >
                {t('confirmation:MotorInsurance:buttonText')}
              </Button>
            </Card>
          </Layout.Item>
          <Layout.Item default="1/2" s="1/1">
            <Card
              onClick={trackExitToPayByPhone}
              imageSrc={imagePayByPhone}
              ariaLabel={t('confirmation:PayByPhoneTitle')}
              title={t('confirmation:PayByPhoneTitle')}
              subtitle={t('confirmation:PayByPhoneText')}
              element="article"
            >
              <Button
                link
                secondary
                element="a"
                target="_blank"
                icon="semantic-forward"
                href={t('confirmation:PayByPhone:link')}
              >
                {t('confirmation:PayByPhone:buttonText')}
              </Button>
            </Card>
          </Layout.Item>
        </Layout>
      </ContentSection>
    </React.Fragment>
  )
}
